import { AppUpdate, AppUpdateAvailability } from "@capawesome/capacitor-app-update";
import { Capacitor } from "@capacitor/core";

const IOS_APP_STORE_ID = "6575383509";
const IOS_APP_STORE_COUNTRY = "au";

export type AppUpdateCheckResult = {
  available: boolean;
  version: string | null;
};

export async function checkAppUpdate(): Promise<AppUpdateCheckResult> {
  try {
    const info = await AppUpdate.getAppUpdateInfo({ country: IOS_APP_STORE_COUNTRY });
    return {
      available: info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE,
      version: info.availableVersionName ?? info.availableVersionCode ?? null,
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("[AppUpdate] getAppUpdateInfo failed", e);
    return { available: false, version: null };
  }
}

export async function openAppStore(): Promise<void> {
  if (Capacitor.getPlatform() === "android") {
    await AppUpdate.openAppStore();
  } else {
    await AppUpdate.openAppStore({ appId: IOS_APP_STORE_ID });
  }
}
